import { itx } from "../../translationItx/itx";
import { enumActions } from "../Guide";
import { ToDoItem } from "../ToDoItem";
import StoryLine from "./StoryLine";

class StoryLines_Framework extends StoryLine {
  ////////////
  // Line via prio

  introStepDone = false;

  introStep = (): ToDoItem => {
    return new ToDoItem({
      id: "introStep",
      text: itx("ToDoItemLine.introStep"),
      dontSlideAway: true,
      subSteps: undefined,

      done: (lastToDoElement?: ToDoItem) => {
        return this.introStepDone;
      },
      pattern: (type, lastToDoItem) => {
        return [
          {
            action: enumActions.function,
            func: async (): Promise<void> => {
              this.introStepDone = true;
            },
          },
        ];
      },
      prio: 100,
    });
  };

  ////////////////////////////////////////////////////////////////////////

  ////////////////////////////////////////////////////////////////////////

  ////////////////////////////////////////////////////////////////////////

  select_A = (): ToDoItem => {
    return new ToDoItem({
      id: "select_A",
      text: itx("ToDoItemLine.followingStorylinesNotDone"),
      subSteps: undefined,
      dontSlideAway: true,
      interactiveSelection: () => {
        const options = new Array<{ text: string; execute: () => void }>();

        let index = 0;
        state.guideMode.allStoryLines.forEach((storyLine) => {
          storyLine.index = index++;

          if (!storyLine.allStepsAreDone()) {
            options.push({
              text: storyLine.description(),
              execute: async () => {
                //
                // Nur nur zur stabilisierung.
                // Insbesondere blebt im Moment noch eine Dialog nach KnxAddressGeneation offen
                //
                if (state.dialogManager.currentDialog) {
                  state.dialogManager.closeDialog();
                }

                state.guideMode.currentStorylineIndex = storyLine.index;
                state.guideMode.startCurrentStoryline(false);
              },
            });
          }
        });

        return options;
      },
      pattern: (type, lastToDoItem) => {
        return [];
      },
      //nextStep: ToDoItemsInLine.createRoom,
      done: (lastToDoElement?: ToDoItem) => {
        return false;
      },
      prio: 1,
    });
  };

  ////////////////////////////////////////////////////////////////////////
  ////
}

const storyLines_Framework = new StoryLines_Framework();
export default storyLines_Framework;
